import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export interface UrgentSourcingRaisedRequestFilters {
  page_no?: number;
  search_text?: string;
  raised_by?: FilterValue[];
  catalog_creator?: FilterValue[];
  product_created_by?: FilterValue[];
  limit?: number;
  sort_by?: string;
  sort_type?: SortType;
  status?: FilterValue[];
}

export const OrderStatusFilter: FilterValue[] = [
  { id: "0", value: "Active" },
  { id: "1", value: "Closed" },
  { id: "2", value: "Cancelled" },
];
